import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import { Loader } from '../../../_metronic/helpers';
import Veranda from './veranda';
import Unit from './unit';
import {
  getVerandaTypes,
  getVerandaPrices,
  getUnitPrices,
  getProductTypes,
  getColors,
  getUnitTypes,
  clearState,
} from './priceActions';

const PricePage = ({
  loading,
  getVerandaTypes,
  getVerandaPrices,
  getUnitPrices,
  getProductTypes,
  getColors,
  getUnitTypes,
  clearState,
}) => {
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState('veranda');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      if (activeTab === 'veranda') {
        await Promise.all([getVerandaTypes(), getVerandaPrices()]);
      } else {
        await Promise.all([getUnitPrices(), getProductTypes(), getColors(), getUnitTypes()]);
      }
      setIsLoading(false);
    };

    fetchData();

    return () => {
      clearState();
    };
  }, [activeTab, clearState, getColors, getProductTypes, getUnitPrices, getUnitTypes, getVerandaPrices, getVerandaTypes]);

  const breadcrumbs = [
    {
      title: intl.formatMessage({ id: 'PRICE.BREADCRUMB.TITLE' }),
      path: '/price-management',
      isSeparator: false,
      isActive: false,
    },
    {
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>
        {activeTab === 'veranda'
          ? intl.formatMessage({ id: 'VERANDA.BREADCRUMB.DESCRIPTION' })
          : intl.formatMessage({ id: 'UNIT.BREADCRUMB.DESCRIPTION' })}
      </PageTitle>
      <div className='card'>
        <div className='card-header card-header-stretch'>
          <div className='card-toolbar'>
            <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
              <li className='nav-item'>
                <button
                  className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${activeTab === 'veranda' && 'active'}`}
                  onClick={() => setActiveTab('veranda')}
                >
                  {intl.formatMessage({ id: 'VERANDA.BREADCRUMB.TITLE' })}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link btn btn-color-gray-600 btn-active-color-primary fw-bolder px-4 me-1 ${activeTab === 'unit' && 'active'}`}
                  onClick={() => setActiveTab('unit')}
                >
                  {intl.formatMessage({ id: 'UNIT.BREADCRUMB.TITLE' })}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className='card-body'>
          {isLoading || loading ? <Loader /> : activeTab === 'veranda' ? <Veranda /> : <Unit />}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.Price.loading,
});

const mapDispatchToProps = {
  getVerandaTypes,
  getVerandaPrices,
  getUnitPrices,
  getProductTypes,
  getColors,
  getUnitTypes,
  clearState,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricePage);
